var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CaseList',{attrs:{"propTitle":"案件管理","propCaseMode":_vm.case_mode}})}
var staticRenderFns = []

export { render, staticRenderFns }